/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./calculation.vue?vue&type=template&id=28e60f95&scoped=true"
import script from "./calculation.vue?vue&type=script&lang=js"
export * from "./calculation.vue?vue&type=script&lang=js"
import style0 from "./calculation.vue?vue&type=style&index=0&id=28e60f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e60f95",
  null
  
)

export default component.exports